<template>
    <div :class="classes">
        <div>
            <h4 class="tw-text-secondary">{{ sectionTitle }}</h4>
            <v-card id="table_card" class="d-flex flex-row container-fluid" flat>
                <v-card-text class="pa-0 d-block">
                    <div>
                        <v-layout child-flex>
                            <slot></slot>
                        </v-layout>
                        <div v-if="hasButton" class="py-2">
                            <v-btn class="mr-2 main-btn" @click="buttonClicked" :loading="isLoading">{{ buttonText }}</v-btn>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
export default {
    name: "InternalTableSection",
    props: {
        sectionTitle: {
            type: String,
            required: false,
        },
        section_class: {
            type: String,
            required: false
        },
        default_class: {
            type: String,
            required: false
        },
        hasButton: {
            type: Boolean,
            default: true,
        },
        buttonText: {
            type: String,
            required: false,
        },
        isLoading: {
            type: Boolean,
            required: false,
        }
    },
    data() {
        return {
            headersEvents: [],
            searchEvents: "",
        };
    },
    computed: {
        classes() {
            if (this.default_class === 'false') {
                return this.section_class
            } else {
                return 'tw-flex tw-flex-col tw-w-full tw-p-6 tw-rounded-lg tw-shadow ' + this.section_class
            }
        }
    },
    methods: {
        buttonClicked() {
            this.$emit('button-clicked');
        },
        showEvent() {
            // do something when a row is clicked
        },
        addEvent() {
            // do something when the button is clicked
        },
    },
};
</script>

<style>
/* Add any necessary styles here */
</style>
